module.exports = __webpack_public_path__ + "media/images/app/benefits/shipping-387dee7c22cf8d8c947df6d4f578531e.webp";